import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { CountryCode } from "../../../models/CountryCode";
import type { RootState } from "../../../store";
import type { UUID } from "../../../utils";
import type { ObjectWithId } from "../../../utils/ObjectWithId";
import type { Customer } from "../models/Customer";

export interface SliceState {
  customer?: Customer;
  banksByCountry: CountryCode[];
  banksCountByCountry: [];
  polling: boolean;
}

/**
 * @deprecated Since the introduction of RTK
 */
export const initialState: SliceState = {
  customer: undefined,
  banksByCountry: [],
  banksCountByCountry: [],
  polling: false,
};

/**
 * @deprecated Since the introduction of RTK
 */
export const slice = createSlice({
  name: "customer",
  initialState,
  reducers: {
    setCustomer: (
      state,
      action: PayloadAction<{ id: string; item: Customer }>
    ) => {
      state.customer = action.payload.item;
    },
    setCustomerBanksByCountry: (
      state,
      action: PayloadAction<CountryCode[]>
    ) => {
      state.banksByCountry = action.payload;
    },
    startPolling: (state) => {
      state.polling = true;
    },
    cancelPolling: (state) => {
      state.polling = false;
    },
  },
});

/**
 * @deprecated Since the introduction of RTK
 */
export const fetchCustomer = createAction<ObjectWithId, "fetchCustomer">(
  "fetchCustomer"
);

/**
 * @deprecated Since the introduction of RTK
 */
export const fetchCustomerBanksByCountry = createAction<ObjectWithId>(
  "fetchCustomerBanksByCountry"
);

export const {
  setCustomer,
  setCustomerBanksByCountry,
  startPolling,
  cancelPolling,
} = slice.actions;

/**
 * @deprecated Since the introduction of RTK
 */
export const selectCustomer = (state: RootState) => state.customer.customer;

/**
 * @deprecated Since the introduction of RTK
 */
export const selectCustomerBanksByCountry = (state: any) =>
  state.customer.banksByCountry;

/**
 * @deprecated Since the introduction of RTK
 */
export const selectPollingStatus = () => (state: RootState) =>
  state.customer.polling;

/**
 * @deprecated Since the introduction of RTK
 */
export const customerOperationPaths = (id?: UUID) => {
  const operationPathBase = ["customers", "items", id];

  return {
    details: [...operationPathBase, "details"],
  };
};

export default slice.reducer;
